/* ============================================================
   KlinikBondage Store Locator – store-locator.js
   ============================================================ */

(function () {
  'use strict';

  var customIcon = null;
  var map = null;
  var markers = [];

  function getIcon() {
    if (!window.L) return null;
    if (customIcon) return customIcon;
    var logoUrl = window.SL_LOGO_URL || '';
    var logoImg = logoUrl
      ? '<img src="' + logoUrl + '" alt="" width="30" height="30" style="display:block;width:30px;height:30px;object-fit:contain;">'
      : '';
    var html = ''
      + '<div style="display:flex;flex-direction:column;align-items:center;">'
      +   '<div style="width:40px;height:40px;border-radius:50%;background:#ffffff;border:1.5px solid #cccccc;box-shadow:0 2px 8px rgba(0,0,0,0.35);display:flex;align-items:center;justify-content:center;flex-shrink:0;overflow:hidden;">'
      +     logoImg
      +   '</div>'
      +   '<div style="width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-top:12px solid #1a1a1a;margin-top:-1px;"></div>'
      + '</div>';
    customIcon = L.divIcon({
      html: html,
      iconSize: [40, 54],
      iconAnchor: [20, 54],
      popupAnchor: [0, -56],
      className: ''
    });
    return customIcon;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildPopupHTML(store) {
    var html = '<div class="sl-popup">';
    html += '<p class="sl-popup__name">' + escapeHtml(store.name) + '</p>';
    html += '<p class="sl-popup__address">' + escapeHtml(store.address) + '</p>';
    if (store.hours) {
      html += '<p class="sl-popup__hours">' + escapeHtml(store.hours) + '</p>';
    }
    if (store.phone) {
      html += '<p class="sl-popup__contact">' + escapeHtml(store.phone) + '</p>';
    }
    if (store.email) {
      html += '<p class="sl-popup__contact">' + escapeHtml(store.email) + '</p>';
    }
    html += '</div>';
    return html;
  }

  // ── Map – wird via onload des Leaflet-Scripts aufgerufen ──────
  function initMap(stores) {
    var mapEl = document.getElementById('sl-map');
    if (!mapEl || !window.L) return;

    map = L.map('sl-map', {
      center: [51.5, 10.0],
      zoom: 6,
      zoomControl: true,
      scrollWheelZoom: true
    });

    L.tileLayer(
      'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
      {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>',
        subdomains: 'abcd',
        maxZoom: 18
      }
    ).addTo(map);

    setTimeout(function () {
      map.invalidateSize();
      document.querySelectorAll('#sl-map .leaflet-control-attribution a').forEach(function (a) {
        a.setAttribute('rel', 'nofollow noopener');
      });
    }, 200);

    stores.forEach(function (store, index) {
      var marker = L.marker([store.lat, store.lng], { icon: getIcon() })
        .addTo(map)
        .bindPopup(buildPopupHTML(store), { maxWidth: 280, minWidth: 220 });

      marker._slIndex = index;
      marker.on('click', function () { highlightCard(index); });
      markers.push(marker);
    });
  }

  // Wird vom Leaflet onload-Attribut aufgerufen
  window.SL_onLeafletReady = function () {
    var stores = window.SL_STORES;
    if (Array.isArray(stores) && stores.length > 0) {
      initMap(stores);
    }
  };

  function focusMarker(index) {
    if (!map || !markers[index]) return;
    map.setView([markers[index].getLatLng().lat, markers[index].getLatLng().lng], 14, {
      animate: true, duration: 0.6
    });
    markers[index].openPopup();
  }

  // ── Store List ───────────────────────────────────────────────
  function buildStoreList(stores) {
    var grid = document.getElementById('sl-store-list');
    if (!grid) return;

    stores.forEach(function (store, index) {
      var card = document.createElement('div');
      card.className = 'sl-store-card';
      card.setAttribute('data-index', index);
      card.setAttribute('data-city', store.city.toLowerCase());

      var inner = '';
      inner += '<p class="sl-store-card__name">' + escapeHtml(store.name) + '</p>';
      inner += '<p class="sl-store-card__city">' + escapeHtml(store.city) + '</p>';
      inner += '<p class="sl-store-card__address">' + escapeHtml(store.address) + '</p>';
      if (store.phone) {
        inner += '<p class="sl-store-card__contact">' + escapeHtml(store.phone) + '</p>';
      }
      if (store.email) {
        inner += '<p class="sl-store-card__contact">' + escapeHtml(store.email) + '</p>';
      }

      card.innerHTML = inner;
      card.addEventListener('click', function () {
        focusMarker(index);
        highlightCard(index);
        scrollToMap();
      });

      grid.appendChild(card);
    });
  }

  function highlightCard(activeIndex) {
    document.querySelectorAll('.sl-store-card').forEach(function (card) {
      card.classList.toggle('is-active', parseInt(card.getAttribute('data-index')) === activeIndex);
    });
  }

  function scrollToMap() {
    var mapEl = document.getElementById('sl-map');
    if (mapEl) mapEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // ── City Filter ──────────────────────────────────────────────
  function initFilter(stores) {
    var select = document.getElementById('sl-city-filter');
    if (!select) return;

    var cities = [];
    stores.forEach(function (store) {
      if (cities.indexOf(store.city) === -1) cities.push(store.city);
    });

    cities.sort().forEach(function (city) {
      var option = document.createElement('option');
      option.value = city.toLowerCase();
      option.textContent = city;
      select.appendChild(option);
    });

    select.addEventListener('change', function () {
      var val = select.value;
      document.querySelectorAll('.sl-store-card').forEach(function (card) {
        card.style.display = (val === 'all' || card.getAttribute('data-city') === val) ? '' : 'none';
      });

      if (!map) return;
      markers.forEach(function (marker, i) {
        var store = (window.SL_STORES || [])[i];
        if (!store) return;
        if (val === 'all' || store.city.toLowerCase() === val) {
          if (!map.hasLayer(marker)) marker.addTo(map);
        } else {
          if (map.hasLayer(marker)) map.removeLayer(marker);
        }
      });

      var visible = markers.filter(function (m) { return map.hasLayer(m); });
      if (visible.length) {
        map.fitBounds(L.featureGroup(visible).getBounds().pad(0.3), { animate: true });
      }
    });
  }

  // ── Init (ohne Karte – die läuft via SL_onLeafletReady) ──────
  function init() {
    var stores = window.SL_STORES;
    if (!Array.isArray(stores) || stores.length === 0) return;
    buildStoreList(stores);
    initFilter(stores);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
